function clientRoundData(prevState, action) {
    return {
        weeks: api(prevState.weeks, 'weeks', action),
        isCompleted: api(prevState.isCompleted, 'isCompleted', action),
        optimal: api(prevState.optimal, 'optimal', action),
        priceActions: api(prevState.priceActions, 'priceActions', action),
        seed: seed(prevState.seed, action),
        competition_id: competitionInfo(prevState.competition_id, 'competition_id', action),
        currentRound: competitionInfo(prevState.currentRound, 'currentRound', action),
        totalRounds: competitionInfo(prevState.totalRounds, 'totalRounds', action),
        displayedRound: competitionInfo(prevState.currentRound, 'displayedRound', action),
        isView: competitionInfo(prevState.isView, 'isView', action)
    }
}
function seed(prevState, action) {
    switch(action.type) {
        case 'seed':
            return action.payload;
        default:
            return prevState;
    }
}
function competitionInfo(prevState, prop, action) {
    switch(action.type) {
        case 'api.PostRoundPriceAction':
            return action.payload.data[prop];
        default:
            return prevState;
    }
}
function api(prevState, prop, action) {
    switch(action.type) {
        case 'api.PostRoundPriceAction':
            return action.payload.data.clientRoundData[prop] !== undefined ?
                action.payload.data.clientRoundData[prop] : prevState;
        default:
            return prevState;
    }
}
function priceActions(prevState, action) {
    switch(action.type) {   
        case 'priceAction':
            return prevState.concat(action.payload === 'same' ? prevState[prevState.length-1] : action.payload);
        case 'priceActions':
            return action.payload;            
        default:
            return prevState;
    }
}
function initedChart(prevState, action) {
    switch(action.type) {
        case 'initedChart':
            return action.payload;
        default:
            return prevState;
    }
}
module.exports = function(prevState = {
		clientRoundData: {
            isCompleted: null,
            optimal: null,
            seed: null,
            totalRounds: null,
            currentRound: null,
            displayedRound: null,
            competition_id: null,
			weeks: [],
            priceActions: [],
		},
        initedChart: false
	}, action) {
    return {
        clientRoundData: clientRoundData(
            prevState.clientRoundData,
            action
        ),
        initedChart: initedChart(
            prevState.initedChart,
            action
        )
    };
};


// WEBPACK FOOTER //
// ../public/js/retailer.student.reducer.js